import React from 'react';

export const LoadingBox = ({ isLoading, data, active, content: Component }) => !isLoading && Boolean(data.length)
    ? Component(data[active])
    : <></>
